import { _ } from "../../core/polyglot/polyglot.js";
import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import HelpWizard from "../../core/chrome/HelpWizard/HelpWizard.js";
import SearchDocumentContent from "./SearchDocumentContent/SearchDocumentContent.js";
import SearchDocumentCoordinator from "./SearchDocumentCoordinator.js";
import SearchDocumentService from "./SearchDocumentService.js";
import SearchDocumentState from "./SearchDocumentState.js";
import session from "../../core/session.js";
import TitleWidget from "../../core/chrome/TitleWidget2.js";

/**
 * Displays a search document with a text input field to search for
 * transactions, ledgers or accounts. The search can be limited to be
 * within an interval of the currently active fiscal year.
 */
export default function makeSearchDocument() {
	const coordinator = new SearchDocumentCoordinator({
		documentState: new SearchDocumentState({
			service: new SearchDocumentService({ session }),
		}),
		renderables: {
			content: new SearchDocumentContent(),
			title: new TitleWidget({
				title: _("Search the ledger"),
				subtitle: _("Find a transaction or an amount"),
				helpWizard: new HelpWizard({ stepsBuilder: makeHelp }),
				helpEnabled: true,
			}),
			periodPicker: null,
		},
	});

	return new AccountingDocument({
		coordinator,
		cssClass: "search-ledger",
		actionsMenuMobileOnly: true,
	});
}

function makeHelp() {
	return [
		{
			title: _("Search the ledger"),
			content: _(
				"This feature searches for accounts and transactions. One can also limit the search to a specific period.",
			),
		},
		{
			title: _("Search results"),
			content: _(
				"As you search for something you will be presented with matching transactions and accounts.",
			),
			element: "search",
		},
	];
}
